import {
  GET_EVENTOS_NO_ASIGNADOS_START,
  GET_EVENTOS_NO_ASIGNADOS_SUCCESS,
  GET_EVENTOS_NO_ASIGNADOS_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const noAsignados = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_EVENTOS_NO_ASIGNADOS_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_EVENTOS_NO_ASIGNADOS_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_EVENTOS_NO_ASIGNADOS_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state
    
  }

}

export default noAsignados